// The new file, d2c-landing-page.constant, will replace this one. (Hold till the home insurance d2c is refactored.)
export const LIST_BENEFITS = [
  { text: "Guaranteed repairs on Buildings Insurance claims" },
  {
    text: "Accidental damage cover, for laptops, tablets, games consoles and TVs, included as standard",
  },
  { text: "Two years no claims discount for first time buyers" },
];
export const LIST_COVERED = [
  { text: "Fire damage" },
  { text: "Floods and storms" },
  { text: "Burglary and vandalism" },
  { text: "Burst pipes and escape of water" },
  { text: "Subsidence and heave" },
];
export const LIST_NOT_COVERED = [
  { text: "Wear and tear" },
  { text: "Negligence" },
  { text: "Lack of maintenance" },
  { text: "Incorrectly supplied information" },
  { text: "Unoccupied properties" },
];
export const INSURERS = [
  {
    name: "",
    url: "insurers-white/axa.png",
    alt: "axa",
  },
  {
    name: "",
    url: "insurers-white/covea.png",
    alt: "covea",
  },
  {
    name: "",
    url: "insurers-white/lv.png",
    alt: "lv",
  },
  {
    name: "",
    url: "insurers-white/rsa.png",
    alt: "rsa",
  },
  {
    name: "",
    url: "insurers-white/ukgeneral.png",
    alt: "ukgeneral",
  },
  {
    name: "",
    url: "insurers-white/zurich.png",
    alt: "zurich",
  },
  {
    name: "",
    url: "insurers-white/prestige.png",
    alt: "prestige",
  },
];
export const TYPE_INSURANCES = [
  {
    title: "Buildings cover",
    description:
      "<p>As a homeowner or soon-to-be homeowner, it's important that you're covered against the unexpected.</p> <p>Getting the right buildings insurance is vital to protect not just your building, but yourself, your family, and home from a variety of situations. It's much more than bricks and mortar; it's the place you call home.</p>",
    icon: "buildings.svg",
  },
  {
    title: "Contents cover",
    description:
      "<p>Your belongings make a house a home. In partnership with a carefully selected group of the UK's best known insurers we strive to offer flexible contents insurance.</p><p> Each insurer is chosen to help us offer insurance for a wide range of properties at competitive prices.</p>",
    icon: "contents.svg",
  },
  {
    title: "Buildings & contents",
    description:
      "<p>If you'd like a combination of both Buildings and Contents Insurance you can protect your home inside and out with a range of options that let you decide how and what you pay for.</p>",
    icon: "buildingscontents.svg",
  },
];
export const ADD_ONS = [
  {
    title: "Home emergency cover",
    description:
      "24-hour access to approved tradespeople for when a home emergency arises. Call out charges and parts & labour costs are covered up to a maximum value.",
    icon: "home-emergency-2.png",
  },
  {
    title: "Legal expenses cover",
    description:
      "Our family legal protection offers you legal cover on a range of unforeseen circumstances such as employment law, property disputes and personal injury.",
    icon: "legal-expenses-2.png",
  },
  {
    title: "Accidental damage cover",
    description:
      "Designed for extra peace of mind in case of mishaps in the home such as hammering a nail through a pipe when hanging a picture or spilling red wine on the carpet.",
    icon: "accidental-damage.png",
  },
  {
    title: "Personal possessions cover",
    description:
      "Cover for accidental loss or damage to items usually worn or carried, like jewellery or mobile phones both in the UK and abroad.",
    icon: "personal-possessions.png",
  },
];
export const WHY_CHOOSE = [
  {
    title: "We're friendly",
    description:
      "Relationships are important to us so we aim to be friendly and approachable at all times.",
    icon: "friendly.jpg",
  },
  {
    title: "We're charming",
    description:
      "We respect our customers and their opinions. Whenever we talk to you we aim to be personable and engaging because you're important to us.",
    icon: "charming.jpg",
  },
  {
    title: "We're big",
    description:
      "We're a market leader and take our responsibilities seriously. We're confident about the difference we can make.",
    icon: "big.jpg",
  },
  {
    title: "We're flexible",
    description:
      "We're big, but not so big that we can't adapt and change. We constantly ask what we could do better and what should we try.",
    icon: "flexible.jpg",
  },
  {
    title: "We're surprising",
    description:
      "We aren't like other insurance companies and we don't want to be. We challenge the norms and stretch ourselves.",
    icon: "surprising.jpg",
  },
  {
    title: "We're premium",
    description:
      "We always take an intelligent approach which enables us to offer exceptional products and services.",
    icon: "premium.jpg",
  },
];

export const HOME_LINK = {
  FAQS: "https://paymentshield.helpshift.com/hc/en/7-d2c/",
  TWITTER: "http://twitter.com/paymentshield",
};

export const HOME_STATIC_DOCUMENTS = [
  {
    code: "terms",
    name: "PolicyBooklet",
    fileName: "Policy Booklet.pdf",
    isDownloading: false,
  },
  {
    code: "ipid",
    name: "PolicySummary",
    fileName: "Policy Summary.pdf",
    isDownloading: false,
  },
];
